enum WebPlatformEnum {
  ios = 'iOS',
  iPadOS = 'iPadOS',
  Safari = 'Safari',
  GenericBrowser = 'GenericBrowser',
}

export default WebPlatformEnum
